import { render } from "./paymentMethod.vue?vue&type=template&id=be661fca"
import script from "./paymentMethod.vue?vue&type=script&lang=js"
export * from "./paymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__